import React, { Component } from 'react'
import 몰루 from '../resources/몰루.gif';
import 아루 from '../resources/아루.gif';
import 노휴먼 from '../resources/노휴먼.jpg';
import 예스휴먼 from '../resources/예스휴먼.jpg';
import life from '../resources/ring.png';
import mol1 from '../resources/mol1.gif';
import mol2 from '../resources/mol2.gif';
import mol3 from '../resources/mol3.gif';
import mol4 from '../resources/mol4.gif';
import help from '../resources/게임설명.jpg';


export class Main extends Component {


    state = {
        level: 0,
        lifeCount: 0,
        count: 0,
        limit: 10, // 시간 제한
        score: 0, // 점수
    }


    // 몰?루
    molu = ()=> {

        var mol = [ mol1, mol2, mol3, mol4 ]
        
        var lifes = document.getElementsByClassName('life');

        var i = this.state.lifeCount;
        this.state.lifeCount+=1;

        if( this.state.lifeCount >= 5 )
        {
            this.gameOver()
            return ;
        }
        setInterval( ()=>{lifes[i].setAttribute('src', mol[i])}, 300 ); 



        // 몰?루 배경 이펙트
        var target = setTimeout( ()=>{ document.body.setAttribute( 'style', 'background-image: url(' + 몰루 + ')'); }, 300 );
        document.body.setAttribute( 'style', 'background-size: cover')
        setTimeout( ()=>{ document.body.setAttribute( 'style', 'background: white') }, 3100 )

    }

    gameOver = () => {

        setTimeout( ()=>{  
            var gameOverScore = document.querySelector('.gameOver .modal .score');

            gameOverScore.innerHTML = "당신의 점수는 " + this.state.score + "점입니다!";


            var gameOverImage = document.querySelector('.gameOver .modal img');
            
            if( this.state.score >= 10 )
                gameOverImage.setAttribute('src', 예스휴먼);
            else
                gameOverImage.setAttribute('src', 노휴먼);

            var gameOverMenu = document.querySelector('.gameOver .modal');
            gameOverMenu.setAttribute('style', 'display: block');
            gameOverMenu.classList.add('show');
    }, 100 )


    
    
    }
    

    clear = () => { // 정답

        // 아!루 배경 이펙트
        var target = setTimeout( ()=>{ document.body.setAttribute( 'style', 'background-image: url(' + 아루 + ')'); }, 300 );
        document.body.setAttribute( 'style', 'background-size: cover')
        setTimeout( ()=>{ document.body.setAttribute( 'style', 'background: white') }, 3100 )


        this.state.count = 0; // 타이머 초기화
        this.troubleMaker(); // 새로운 문제 생성

        this.state.score += 1;
        document.querySelector('.ingameScore').innerHTML = this.state.score + '점';

    }

    fail = () => { // 오답
        
        this.state.count = 0; // 타이머 초기화
        this.troubleMaker(); // 새로운 문제 생성
        this.molu(); // 생명력 깎기

        this.state.score -= 1;
        document.querySelector('.ingameScore').innerHTML = this.state.score + '점';
    }

    // 문제 만드는 녀석
    troubleMaker = ()=> {

        this.state.level++;
        

        var counter = document.getElementsByClassName('counter')[0];
        var question = document.getElementsByClassName('question')[0];
        var btn = document.querySelectorAll('.buttons .btn');

        var level = this.state.level;

    

        counter.innerHTML = level + '번 문제!';


        const operations = [ '+', '-', '*', '/', '%' ]; // 연산자
        var space = ' '; // 공백
        var problem = 0;

        // 문제 생성

        function rand( n ){ return Math.floor(Math.random() * n + 1) }; // 난수 생성

        if(this.state.level <= 10 ){ // 난이도가 10 레벨 이하일 경우

            problem = rand( 11 ) + space + operations[ Math.floor(Math.random() * 5) ] + space +  rand( 11 );
            var answer = ( eval( problem ) ); // 정답

        }else if( this.state.level >= 10 ){

            problem = rand( 11 ) + space + operations[ Math.floor(Math.random() * 5) ] + space +  rand( 11 ) + space + operations[ Math.floor(Math.random() * 5) ] + space +  rand( 11 );
            var answer = ( eval( problem ) ); // 정답

        }


        if( ! Number.isInteger( answer ) ){ // 실수 형태일 경우 반올림
            answer = (answer).toFixed(2);
        }


        question.innerHTML = problem + ' = ?' ; // 문제 제시


        var faker = []; // 가짜 정답들
        var n = 0;


        for( let i=0; i<3; i++ ){
            var caseType = Math.floor( Math.random() * 2 ); // 더할지 뺄지
            
            
            if( caseType )
            {
                n = Number(answer) + Math.floor( Math.random() * 5 + 1 );

                // 똑같은 결과가 있으면 다시 바꿈
                for( let j=0; j<faker.length; j++ ){
                    if( faker[j] === n ){
                        n = Number(answer) + Math.floor( Math.random() * 5 + 1 );
                        j--;
                    }
                }
                
                faker.push( n );
            }
            else
            {
                n = Number(answer) + Math.floor( Math.random() * 5 + 1 );
                // 똑같은 결과가 있으면 다시 바꿈
                for( let j=0; j<faker.length; j++ ){
                    if( faker[j] === n ){
                        n = Number(answer) + Math.floor( Math.random() * 5 + 1 );
                        j--;
                    }
                }

                faker.push( n );
            }
        
        
        }

        faker.splice( Math.floor( Math.random() * 3 ), 0, answer ); // 정답 끼어넣기




        // 보기 제공
        for( let i=0; i<btn.length; i++ ){
            
            
            btn[i].innerHTML = faker[i];

            if( faker[i] === answer ){
                btn[i].onclick = ()=>{ this.clear() } // 정답
            } else{
                btn[i].onclick = ()=>{ this.fail() } // 오답

            }

            

        }



    }


    // 게임 시작
    start = ()=>{

        var gameStartMenu = document.querySelector('.gameStart .modal');
        document.querySelector('.gameStart .modal').classList.remove('show'); // 시작 메뉴 없애기
        document.querySelector('.gameStart .modal').setAttribute('style', 'display: none');


        this.troubleMaker(); // 문제 만드는 녀석

        var limit = this.state.limit; // 제한 시간


        
        // 타이머
        var timer = setInterval( ()=>{

            var progress = document.querySelector('.progress .progress-bar');
            progress.setAttribute('style', 'width: '+ this.state.count / limit * 10+ '%' );
            progress.innerHTML = this.state.count / 10 + '초 / ' + limit + ' 초'
            this.state.count++;

            if( ( this.state.count / limit * 10 ) >= 101 ){ // 타임 오버
                //clearInterval( timer );
                
                this.state.count = 0; // 타이머 초기화

                if( this.state.lifeCount <= 3 ){
                    this.molu(); // 생명 깎기
                    this.troubleMaker(); // 문제 생성
                    this.state.score -= 1; // 점수 깎기
                    document.querySelector('.ingameScore').innerHTML = this.state.score + '점';
                    console.log( this.state.lifeCount  )
                }
                else{
                    this.state.score -= 1; // 점수 깎기
                    document.querySelector('.ingameScore').innerHTML = this.state.score + '점';
                    this.gameOver(); // 게임 오버
                    clearInterval(timer);

                }
            }

            if( this.state.lifeCount >= 5 )
                clearInterval(timer);

        }, 100 )



    }

    componentDidMount(){


        

    }


    render() {
        return (
            <div>



                <div class='gameStart'>
                    <div class="modal fade show" id="staticBackdropLive" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLiveLabel" style={{ "display": "block"}} aria-modal="true" role="dialog">
                    <div class="modal-dialog">
                        <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="staticBackdropLiveLabel">몰?루의 산수교실</h5>

                        </div>
                        <div class="modal-body">
                            <p>게임 설명</p>
                            <img className='w-100' src={help}></img>


                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-primary" onClick={ ()=>{ this.start() } }>게임 시작</button>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>



                <div class='gameOver'>
                    <div class="modal fade" id="staticBackdropLive" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLiveLabel" style={{ "display": "none"}} aria-modal="true" role="dialog">
                    <div class="modal-dialog">
                        <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="staticBackdropLiveLabel">게이 오버</h5>

                        </div>
                        <div class="modal-body">
                            <h4 class='score'>당신의 점수는 N점입니다!</h4>
                            
                            <img className='w-50' src={노휴먼}></img>


                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-primary" onClick={ ()=>{ window.location.reload() } }>다시하기</button>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>



                <div class="container">
                    

                    <div class="row">
                        <div class="col-md-2"></div>
                        <div class="col-md-8 border border-warning rounded-2 bg-white">
                            
                        <div class="progress my-2">
                            <div class="progress-bar" role="progressbar" style={ {"width":"38%"} } aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">  ( 1초 / 10초 ) </div>
                        </div>


                            <h4 class='my-4 counter'>N번 문제!</h4>
                            <div class="mb-4 question"> 2 X 1 = ? </div>

                            <div class="mb-4 buttons">
                                <button type="button" class="btn btn-outline-primary m-1 w-30">2</button>
                                <button type="button" class="btn btn-outline-primary m-1 w-30">3</button>
                                <br/>
                                <button type="button" class="btn btn-outline-primary m-1 w-30">4</button>
                                <button type="button" class="btn btn-outline-primary m-1 w-30">5</button>
                            </div>


                        <div class="row mb-4">
                        
                        <div class="col-3">
                            <img class='life w-100' src={life} alt="molu"></img>
                        </div>
                        <div class="col-3">
                            <img class='life w-100' src={life} alt="molu"></img>
                        </div>
                        <div class="col-3">
                            <img class='life w-100' src={life} alt="molu"></img>
                        </div>
                        <div class="col-3">
                            <img class='life w-100' src={life} alt="molu"></img>
                        </div>                        

                        </div>


                        </div>
                        <div class="col-md-2"> <span class='ingameScore'>0점</span> </div>
                    </div>

                </div>

                
            
            
            
            </div>
        )
    }
}

export default Main
